<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <filtros :tipo=" funcionarioId<=0 ? 'notificacao' : 'notificacaoUsuarioLogado' "  
        @filtrar="filtrar($event)" :exportExcel="funcionarioId<=0" @exportar="exportar($event)" 
        :listaStatus="getStatus()" :funcionarioId="funcionarioId"></filtros>
        <div v-if="isLoading">
            <b-loading active></b-loading>
        </div>
        <div v-else>     

            <b-table v-if="lista.length>0" :data="lista"
                    :loading="isLoading"                    
                    striped
                    hoverable                                                            
                    backend-sorting
                    sort-icon-size="is-small"
                    :row-class="(row, index) => isMensagem(row) ">                    

                <template >

                    <b-table-column v-slot="props" field="Data" :label="$t('SISTEMA.DATA')" >
                        {{ $moment(props.row.dataHora).format("DD/MM/YYYY HH:mm") }}
                        <br><span  class="is-size-7"><b>Tipo:</b>  {{ (props.row.tipo == 0) ? 'Aviso' :  (props.row.tipo == 1) ? 'Atraso' : 'Mensagem' }} </span>
                    </b-table-column>

          

                    <b-table-column v-slot="props" field="Nome" :label="$t('SISTEMA.NOME')" >                        
                            <span  v-if="isMensagem(props.row)" > <b> 
                                <b-icon  icon="email-outline" ></b-icon></b> 
                            </span>                        
                            {{ props.row.descricao }}
                            <table  v-if="props.row.respostas!=null && props.row.respostas.length>0" class="table is-fullwidth">
                                <tr v-for="(resp, index) in props.row.respostas" :key="index">
                                    <td class="is-size-7 "><b>>>></b> {{ resp.observacao }}</td>                                                                        
                                    <td> <span class="is-size-7 "> <b>{{ resp.usuarioNome }}</b>  <br>{{ resp.dataHora | moment('DD/MM/YYYY HH:mm') }}</span></td>                                                                            
                                </tr>                                                                   
                            </table> 
                                          
                    </b-table-column>


                    <b-table-column v-slot="props" field="Funcionario" label="Remetente" >
                        {{ props.row.funcionarioRemetenteNome }}
                        <br><span  class="is-size-7"><b>Unidade:</b>   {{ props.row.unidadeNome }}</span>
                    </b-table-column>     

                    <b-table-column v-slot="props" field="FuncionarioComercial" :label="$t('GUIAATENDIMENTO.VENDEDOR')" >
                        {{ props.row.funcionarioComercialNome }}                        
                    </b-table-column>                         


                    <b-table-column v-slot="props" field="Atendimento" :label="$t('SISTEMA.CLIENTE')" >
                        {{ props.row.clienteNome }}

                        <b-button v-if="props.row.guiaId && props.row.guiaId >0 " class="is-primary is-small is-pulled-right" icon-left="pencil"                                    
                                @click="abrirGuia(props.row.guiaId,props.row.unidadeId,props.row.statusGuia)" title="Abrir Projeto"></b-button>   

                    </b-table-column>                     

                </template>
            </b-table>              
          
        </div>
    </section>
</template>

<style lang="scss" scoped>

    .mensagem-color{
        background-color: rgba(185, 209, 0, 0.159) !important;
    }

</style>

<script>
    import { mapGetters,mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import filtros from '@/components/filtrosRelatorio.vue';

    export default {
        data() {
            return {
                isLoading: false ,
                lista:[],
                funcionarioId: this.$route.params.funcionarioId ?? 0,  
            }
        },
        components: {
            titlebar,
            filtros
        },
        computed: {
            titleStack() {
                return [
                    'Relatório',                                        
                    'Sistema',
                    'Notificação'
                ]
            },
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState([
                'unidadeId',
                'config',                                             
                'usuario', 
            ]),            
        },        
        
        mounted(){
            return true;
        },
        methods: {
            getStatus(){

                 const listaStatus = [
                                    {id:"aviso", descricao:"Avisos"},
                                    {id:"mensagem", descricao:"Mensagem"}                                    
                                ];


                return listaStatus;

            },            
            isMensagem(item){

                return item.tipo == 2 ? ' mensagem-color ' : null;

            },             
            abrirGuia(guiaId,unidadeId,status){

                if(status==0){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId, bloquearVoltarTela:true}})
                }else if (status == 1){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,fluxoVenda:true, bloquearVoltarTela:true }})
                }else if(status == 5){
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,fluxoVenda:true, bloquearVoltarTela:true }})
                }else{
                    this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId, bloquearVoltarTela:true}})
                }
                
                this.$parent.close();

            },            

            filtrar(filtros){

                    const params = {                        
                        dataFiltro: (filtros.dataFiltro !=null) ? filtros.dataFiltro : null,
                        status: (filtros.status !=null) ? filtros.status : null,
                        dataInicial: (filtros.datas[0] !=null)  ? this.$moment(filtros.datas[0]).format('YYYY-MM-DDTHH:mm:ss') : null,
                        dataFinal:  (filtros.datas[1] !=null) ?  this.$moment(filtros.datas[1]).format('YYYY-MM-DDTHH:mm:ss') : null,
                        funcionarioId: (filtros.funcionario?.id != null) ? filtros.funcionario?.id : null ,                                                
                        funcionarioLogadoId: this.usuario.funcionarioId,                        
                    }


                    if (filtros.unidade?.id != null){                         
                        params.unidadeId = filtros.unidade?.id;
                    }else if (filtros.unidade?.id == null && !this.usuario.administrador){ 
                        params.unidadeId = this.unidadeId;
                    }                    

                this.carregarLista(params);  

            },

            exportar(filtros){

                    const params = [];

                    if (filtros.dataFiltro != null) params.push(`dataFiltro=${filtros.dataFiltro}`);
                    if (filtros.status != null) params.push(`status=${filtros.status}`);
                    if (filtros.datas[0] != null) params.push(`dataInicial=${this.$moment(filtros.datas[0]).format('YYYY-MM-DDTHH:mm:ss')}`);
                    if (filtros.datas[1] != null) params.push(`dataFinal=${this.$moment(filtros.datas[1]).format('YYYY-MM-DDTHH:mm:ss')}`);
                    if (filtros.funcionario?.id!= null) params.push(`funcionarioId=${filtros.funcionario?.id}`);
                    
                    
                    if (filtros.unidade?.id != null){ 
                        params.push(`unidadeId=${filtros.unidade?.id}`);   
                    }else if (filtros.unidade?.id == null && !this.usuario.administrador){ 
                        params.push(`unidadeId=${this.unidadeId}`);   
                    }
                    
                    params.push(`funcionarioLogadoId=${this.usuario.funcionarioId}`);                     
                                                                                                                                                                                                                                                            
                    window.open(`/api/relatorio/NotificacaoXLS?${params.join('&')}`,'_blank');
                
            },                              
            carregarLista(params){   
                
                    this.isLoading = true;
                    this.$http.post('/api/relatorio/Notificacao', params)
                    .then(res => res.data)
                    .then(data => {                         
                            this.lista = data;                           
                    }).finally(() => {
                        this.isLoading = false;
                    })
                    
            },
 
            
        }
    }
</script>